<template>
    <ProseCode language="bash" :code="`pip install -U pathway`">
        <pre>
            <code>pip install -U pathway</code>
        </pre>
    </ProseCode>
</template>

<style scoped>
a {
    display: inline;
    border-bottom-width: 1px;
    border-color: transparent;
    font-weight: 500;
    color: #61AFEF;
    text-decoration-line: none;
}

a:hover {
    text-decoration: underline;
}
</style>
